<template>
  <div class='upgrading-conditions-wrap'>
    <div class='title fx-row fx-m-between'>
      <div class='a-text-17 a-lightblack a-text-medium'>升级条件</div>
      <div class='a-text-15 a-blue' @click='gotoExplain'>会员说明</div>
    </div>
    <div class='conditions fx-row fx-m-between'>
      <div class='condition-item' v-for="(item, index) in list" :key='index' :style="{backgroundImage: 'url('+item.describeicon+')'}">
        <div class='a-text-15 a-lightblack condition-des'>{{item.describe}}</div>
        <div class='orange-1 fx-row fx-c-center a-text-16'>{{item.describevalue}}<span class='a-gray'>{{item.describeunit}}</span></div>
        <img src='https://cdn.133.cn/gtgj/vipcard/standard.png' alt='' class='icon-tag' v-if="item.describeIsfinish" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentIndex: {
      type: [Number, String],
      required: true
    },
    levelName: String,
    list: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    experienceNum() {
      const _all = {
        'silver': 3000,
        'gold': 10000,
        'platinum': 30000,
        'diamond': 100000
      };
      return _all[this.level];
    }
  },
  methods: {
    gotoExplain() {
      this.$router.push({
        name: 'vipCard/explain',
        params: {
          level: this.currentIndex
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

$orange-1: #FF9500;

.upgrading-conditions-wrap {
  background: #ffffff;
  padding: 20 * $px 14 * $px;
  margin-bottom: 8 * $px;
  .orange-1 {
    color: $orange-1;
  }
  .icon-tag {
    width: 43 * $px;
    height: 43 * $px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .title {
    line-height: 24 * $px;
    margin-bottom: 14 * $px;
  }
  .condition-item {
    position: relative;
    width: 166 * $px;
    height: 81 * $px;
    padding-left: 14 * $px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% 100%;
    .condition-des {
      margin: 14 * $px 0 10 * $px;
      line-height: 21 * $px;
    }
    .a-arrow {
      border-color: $orange-1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/components/home-upgrade-about.vue